export const scrollToSection = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    const navHeight = 80; // Height of fixed navigation
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - navHeight;
    
    // For better UX, instantly scroll to the target position
    // This prevents the disorienting effect of scrolling from bottom to top
    window.scrollTo({
      top: offsetPosition,
      behavior: 'auto' // Use 'auto' for instant scrolling
    });
    
    // Optionally, you can add a small smooth scroll at the end for polish
    // This gives a subtle settling effect without the long scroll animation
    setTimeout(() => {
      const finalPosition = element.getBoundingClientRect().top + window.scrollY - navHeight;
      if (Math.abs(window.scrollY - finalPosition) > 5) {
        window.scrollTo({
          top: finalPosition,
          behavior: 'smooth'
        });
      }
    }, 50);
  }
};